"use client";

import { toast } from "@/components/ui/sonner";

type CopyTextToastOptions = {
  successTitle: string;
  errorTitle: string;
  successDescription?: string;
};

export async function copyTextWithToast(
  text: string,
  options: CopyTextToastOptions,
): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    toast.success(options.successTitle, {
      description: options.successDescription,
    });
    return true;
  } catch (error) {
    toast.error(options.errorTitle, {
      description:
        error instanceof Error ? error.message : "Clipboard permission denied.",
    });
    return false;
  }
}
